// Distinguishes Statara-era audiences from the new Nexxen-direct hashed-email
// pipeline. Legacy audiences must stay visible (they may be Activated and
// live in Nexxen with campaigns attached) but are read-only: they can be
// viewed or deleted, but never re-processed/re-published through the new
// pipeline.
//
// Markers, in priority order:
//   - typeOfFirstPartyData "phones" / "lookalike" -> legacy (new pipeline is
//     emails only), regardless of whether a segment id exists yet.
//   - dsp "LIQUIDM" -> legacy (new pipeline only publishes to Nexxen).
//   - a dspSegmentIds entry whose segmentId is prefixed "hem-statara-",
//     "statara-lal-", or "statara-hpn-" -> legacy.
// An audience with no dspSegmentIds yet (freshly uploaded, not published) is
// NOT legacy - it simply hasn't gone through the new pipeline yet. A
// "mediajel-hem-..." segmentId prefix is the new pipeline's own marker, so
// it is explicitly not legacy.

import { resolveDspName } from './dspDisplay';

const LEGACY_SEGMENT_ID_PREFIXES = ['hem-statara-', 'statara-lal-', 'statara-hpn-'];
const LEGACY_DATA_TYPES = ['phones', 'lookalike'];
const LEGACY_DSP = 'LIQUIDM';

const hasLegacySegmentId = (dspSegmentIds) => {
  if (!Array.isArray(dspSegmentIds)) return false;

  return dspSegmentIds.some((entry) => {
    if (!entry || typeof entry !== 'object') return false;
    const { segmentId } = entry;
    if (typeof segmentId !== 'string') return false;
    return LEGACY_SEGMENT_ID_PREFIXES.some((prefix) => segmentId.startsWith(prefix));
  });
};

/**
 * True if `audience` (a hashedEmailList record) belongs to the Statara-era
 * pipeline and should be shown as legacy / read-only in the audience list.
 * Never throws, even for null/undefined/malformed input.
 */
export const isLegacyAudience = (audience) => {
  if (!audience || typeof audience !== 'object') return false;

  if (LEGACY_DATA_TYPES.includes(audience.typeOfFirstPartyData)) return true;

  const effectiveDsp = resolveDspName(audience);
  if (typeof effectiveDsp === 'string' && effectiveDsp.toUpperCase() === LEGACY_DSP) return true;

  return hasLegacySegmentId(audience.dspSegmentIds);
};

export default isLegacyAudience;
